import Enum from "../../../enums/Enum";

const DirectBillingObservationTypeEnum = new Enum({
    //LOINC: {name: "Loinc"},
    TEXT: {name: "Text"},
    FILE: {name: "File"}
});

export default DirectBillingObservationTypeEnum;
